/**
 * Shared constants for the SSO sign-in path. Centralizes the sessionStorage
 * keys and error codes that were previously duplicated as raw string literals
 * across the guard, login card, SSO callback, and error page.
 */

/** sessionStorage keys used during the SSO flow. */
export const SSO_STORAGE_KEYS = {
  /** The Keycloak IdP alias chosen for the current SSO attempt. */
  PROVIDER: 'sso_provider',
} as const;

/** Error-page `code` values emitted by the SSO flow. */
export const SSO_ERROR_CODES = {
  /** Generic SSO sign-in failure. */
  SSO_FAILED: 'sso-failed',
} as const;
